import { WithTranslation } from 'react-i18next';
import { SupportedLangsEnum } from '../enums/supportedLangs.enum';

/*
 TODO this function need only for plurals for es language, in spanish we can not use plurals like this number_of_reviews_1 
 delete this function after migration to compatibilityJSON: 'v3'
 */
export const overrideTFn = (t: WithTranslation['t'], i18n: WithTranslation['i18n']) => {
  const overridedTFn = (key: string, options: Record<string, number | string> = {}) => {
    const context =
      i18n.language === SupportedLangsEnum.es && typeof options.count === 'number'
        ? `${Math.max(Math.min(options?.count, 3) - 1, 0)}`
        : undefined;
    return t(key, {
      ...options,
      context,
    });
  };
  return overridedTFn as WithTranslation['t'];
};
